import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';
import { irsaudittableDetail } from './irsaudittableDetails';

@Injectable()
export class IrsauditService {
  private apiurl = CONFIGURATION.basefile1094CURL + 'audit/';
  constructor(private _http: Http) { }

  GetTaxyer(): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'tax-year', { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  getControlGroup(data: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'control-group?taxYear=' + data, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  getEin(taxYear: any, CG: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'ein?taxYear=' + taxYear + '&controlGroup=' + CG, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  getReportData(): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'reference-data', { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  getReportsData(selectedYear: any, selectedCG: any, selectedEIN: any): Observable<irsaudittableDetail[]> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    const fileName = 'report-data?taxYear=' + selectedYear
      + '&ein=' + selectedEIN + '&controlGroup=' + selectedCG;
    return this._http.get(this.apiurl + fileName, { headers: headers })
      .map((response: Response) => <irsaudittableDetail[]>response.json())
      .catch(this.handleError);
  }

  downloadxml(data: any): any {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'downloadFile/' + data, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const blob = new Blob([res.blob()], { type: 'application/zip' });
        const downloadUrl = URL.createObjectURL(blob);
        window.open(downloadUrl);
      })
  }

  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
}



// WEBPACK FOOTER //
// ./src/app/irsaudittable/irsaudit.service.ts